import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import ListaControladoModel from "@/models/produto/listaControladoModel";
import listaControladoService from "@/services/produto/listaControladoService";

import ListComponentBase from "../listComponentBase";

@Component
export default class ListaControladoListComponent extends ListComponentBase<ListaControladoModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("codigo", this.$t("__.ts.codigo"), GridColumnType.String),
            new GridColumn("descricao", this.$t("__.ts.descricao"), GridColumnType.String),
        ];
    }

    private beforeMount() {
        this.setPropsCached(listaControladoService, "listacontrolado", "descricao", true);
    }
}
